import { AUTH_REGISTER_PATH } from 'constants/routes';
import { Button, Col, Input, Form, Typography, Row } from 'antd';
import Link from 'next/link';
import GoogleButton from 'components/GoogleButton';
import Image from 'next/image';
import { API_HOSTNAME, APP_LOGO } from 'constants/base';
import { useEffect, useState } from 'react';
const { Title } = Typography;

export default function Login() {
	const [store, setStore] = useState('');

	const handleSubmit = e => {
		e.preventDefault();
		if (!store) return alert('Please enter a valid store url!');
		let finalStore = store;
		finalStore += '.myshopify.com';
		const urlParts = finalStore
			.replace('http://', '')
			.replace('https://', '')
			.split(/[/?#]/);
		finalStore = urlParts[0];
		const url = `${API_HOSTNAME}/shopify/install?shop=${finalStore}`;
		window.location.href = url;
	};

	return (
		<Row style={{ paddingTop: '10rem' }} justify='center'>
			<Col>
				<Image src={APP_LOGO} width={400} height={40} alt='veonr logo' />
				<br />
				<br />
				<br />
				<br />
				{/* <Title style={{ marginBottom: '6rem' }}>~~ VEONR ~~</Title> */}
				{/* <p>Your Shopify Store URL</p>
				<form onSubmit={handleSubmit}>
					<Input
						value={store}
						onChange={e => setStore(e.target.value)}
						addonAfter='.myshopify.com'
						placeholder='example'
					/>
					<br />
					<br />
					<Button htmlType='submit' block>
						LOGIN
					</Button>
				</form>
				<p style={{ margin: '2rem 0' }} className='text-center'>
					OR
				</p> */}
				<GoogleButton />
				{/* <Form
            name="login-form"
            onFinish={handleFinish}
            size="large"
            layout="vertical"
            form={form}
            initialValues={{ email: "", password: "" }}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please enter your email!" }]}
            >
              <Input type="email" />
            </Form.Item>
            <Form.Item>
              <Button block type="primary" htmlType="submit">
                Login
              </Button>
            </Form.Item>
          </Form>
          <p>
            Don't have an account?{" "}
            <Link href={AUTH_REGISTER_PATH}>Sign Up</Link>
          </p> */}
			</Col>
		</Row>
	);
}
